export default __webpack_public_path__ + "static/fabric-kids-c63507bba937d61e6b592e764519f86a.png";